import { render } from "./CreateAutoAnnotationTaskModal.vue?vue&type=template&id=2f8f56ca&scoped=true"
import script from "./CreateAutoAnnotationTaskModal.vue?vue&type=script&lang=js"
export * from "./CreateAutoAnnotationTaskModal.vue?vue&type=script&lang=js"

import "./CreateAutoAnnotationTaskModal.vue?vue&type=style&index=0&id=2f8f56ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8f56ca"]])

export default __exports__